import StructureTeam from './StructureTeam';

export default class Structure {
    public ecosystemId: number = 0;
    public ecosystemKey: string = '';
    public name: string = '';
    public teams: StructureTeam[] = [];
}
